module.exports = __webpack_public_path__ + "media/images/youtube-e67d51e657912633c5bd6b75e21b7f81.svg";